import { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { history } from '../../helpers/history';
import { alertActions } from '../../action/AlertAction';
import { gameActions } from '../../action/GameAction';
import { IframeLoad } from '../Games/IframeLoad';
import CryptoJS from 'crypto-js';
import { commonClass } from '../../helpers/commonClass';

class RenderCasino extends Component {
    constructor(props) {
        super(props);
        this.state = { sratchflxfog: 1 };
        if (this.props.renderkey == 2) {
            this.props.GetCasinoGames(2, this.props.user.mobileNo, this.props.i18n.language, this.props.user.loginKey, this.props.user.Country_code);
        }
    }

    showMsg = (msg, flag) => {
        this.props.alertError(msg);
    }

    showModalPopUp = (url, no, key, _categoryID) => {
        let freewinflag = 0;
        let freewincount = 0;
        let bonusid = 0;
        IframeLoad(url, no, key, _categoryID, this.props, this.showMsg, freewinflag, freewincount, bonusid, this.props.loadingIframe, this.props.loadedIframe);
        return
    };


    static getDerivedStateFromProps(props, state) {
        return { casinogames: props.casinogames };
    };
    componentDidMount() {
        if (this.props.renderkey == 5 && window.ScratchCard) {
            // setTimeout(() => {
            //     window.ScratchCard()
            // }, 2000);

            let tery = setInterval(() => {
                let dd = document.getElementById("scra_0");
                if (dd) {
                    window.ScratchCard()
                    clearInterval(tery);
                }
            }, 100);
        }
    }

    componentDidUpdate(prevState, prevProps) {
    }


    RemoveDuplicate = (casinogames) => {
        casinogames = casinogames.filter(a => a.types == 3)
        if (casinogames) {
            const uniqueGames = Array.from(
                new Map(casinogames.map(game => [game.game_type_id, game])).values()
            );
            return uniqueGames
        }
    }


    LoadPoker = (Obj) => {
        const { user, i18n } = this.props;
        if (user == undefined || user.mobileNo == "0") {
            this.showMsg(this.props.t('lblplsloginTry'))
            setTimeout(() => {
                history.push("/login");
            }, 2000);
            return;
        }
        let lang_val = ""
        if (JSON.parse(localStorage.getItem('language'))) {
            lang_val = JSON.parse(localStorage.getItem('language'))
        }
        else {
            lang_val = 'en'
        }
        debugger
        let lang_val_id = commonClass.langidsel(lang_val);
        const queryData =
            user.Player_name + "~" +
            user.mobileNo + "~" +
            user.loginKey + "~" +
            process.env.REACT_APP_CURRENCY_NAME + "~" +
            'gulfticket' + "~" +
            user.only_wallet + "~" +
            user.winbalance + "~" +
            'M' + "~" +
            (user.isMobileApp ? 1 : 0) + "~" +
            i18n.language + "|" +
            lang_val_id + "~" +
            user.referralid + "~" +
            user.emailID + "~" +
            user.poker_status;

        const secretKey = "A1234&ABCDE/98745";
        const encrypted = CryptoJS.AES.encrypt(queryData, secretKey).toString();
        // Obj.game_icon
        // let url = "http://220.225.104.151/GulfTicket/Poker/lobby.html?qString=" + encrypted + "~" + secretKey
        // let url = "https://pokergames.starteams.in/pokerGame/lobby.html?qString=" + encrypted + "~" + secretKey
        let url = Obj.game_url + "?qString=" + encrypted + "~" + secretKey
        // IframeLoadPoker(queryData);
        let freewinflag = 0;
        // history.push({ pathname: '/slotgame', state: { WindowUrl: url, Userid: user.mobileNo, spintype: freewinflag } })
        let _formobj = { url: url, userid: user.mobileNo, gameid: Obj.game_type_id, type: Obj.types };
        localStorage.setItem('slotgame', JSON.stringify(_formobj));
        history.push('/slotgame')
    }

    render() {
        const { t } = this.props;
        return (
            <>
                {/* renderkey 1 = SliderImageInfo,renderkey 2 = HomeSlidTabs,renderkey 3 = Instant */}
                {this.props.renderkey == 1 && this.state.casinogames && this.state.casinogames.length > 0 && this.state.casinogames.filter(a => a.types == 1 || a.types == 2).slice(0, 4).map((item, inx1) =>
                    <li key={'cas_' + inx1} onClick={() => this.showModalPopUp(item.game_url, item.types, item.game_type_id, item.category_id)}>
                        <a>
                            <img src={item.game_icon} />
                        </a>
                    </li>
                )}

                {this.props.renderkey == 2 && this.state.casinogames && this.state.casinogames.length > 0 && this.state.casinogames.filter(a => a.types == 1 || a.types == 2).map((item, inx1) =>
                    <li key={'cas_' + inx1} onClick={() => this.showModalPopUp(item.game_url, item.types, item.game_type_id, item.category_id)}>
                        <a>{item.game_type_name}
                        </a>
                    </li>
                )}

                {this.props.renderkey == 3 && this.state.casinogames && this.state.casinogames.length > 0 && this.state.casinogames.filter(a => a.types == 1 || a.types == 2)
                    .filter(game =>
                        game.game_type_name?.toLowerCase().includes(this.props.slotnamefilter.toLowerCase())
                    ).map((x, inx) => (
                        <li key={'cas_' + inx} onClick={() => this.showModalPopUp(x.game_url, x.types, x.game_type_id, x.category_id)}>
                            <a >
                                <div >
                                    <img src={x.game_icon} alt="slot Game" />
                                </div>
                                {/* <div className="instGameName">
                                <span className="gameName1">{x.game_type_name}</span>
                            </div>
                            {x.jackpot_amount && x.jackpot_amount != 0 &&
                                <div className="instGameName">
                                    <span className="gameName1">JackPot Amount : {x.jackpot_amount}</span>
                                </div>}
                            <div className="gIconOverlay">
                                <h4>Play Now</h4>
                            </div> */}
                            </a>
                        </li>
                    ))}

                {this.props.renderkey == 4 && this.state.casinogames && this.state.casinogames.length > 0 && this.RemoveDuplicate(this.state.casinogames).filter(a => a.types == 3).map((item, inx1) =>
                    <li key={'scra_' + inx1} onClick={() => this.showModalPopUp(item.game_url, item.types, item.game_type_id, item.category_id)}>
                        <a>{item.game_type_name}
                        </a>
                    </li>
                )}
                {/* {this.props.renderkey == 5 && this.state.casinogames && this.state.casinogames.length > 0 && this.state.casinogames.filter(a => a.types == 3).map((item, inx1) => */}
                {this.props.renderkey == 5 && this.state.casinogames && this.state.casinogames.length > 0 && this.state.casinogames.filter(a => a.types == 3).filter(a => (this.props.SwitchControl == true && a.category_id == 2) || (this.props.SwitchControl == false && a.category_id == 1)).map((item, inx1) =>
                    <li id={'scra_' + inx1} key={'scra_' + inx1} style={{ display: 'none' }} onClick={() => this.showModalPopUp(item.game_url, item.types, item.game_type_id, item.category_id)}>
                        <a>
                            <img src={item.game_icon} />
                        </a>
                    </li>
                )}

                {this.props.renderkey == 6 && this.state.casinogames && this.state.casinogames.length > 0 && this.state.casinogames.filter(a => a.types == 4).map((item, inx1) =>
                    <li id={'tgame_' + inx1} key={'tgam_' + inx1} onClick={() => { item.game_type_id == 11 ? this.LoadPoker(item) : history.push("/" + item.game_url) }}>
                        <a>{item.game_type_name}</a>
                    </li>
                )}

                {/* Loading Home Page In  roluette , poker. */}
                {this.props.renderkey == 7 && this.state.casinogames && this.state.casinogames.length > 0 && <>
                    {this.state.casinogames.filter(a => a.types == 4).length > 5 && <a class="viewAll" onClick={() => { history.push('/allroulette') }}>{t('lblviewall')}</a>}
                    <ul>
                        {this.state.casinogames.filter(a => a.types == 4).slice(0, 5).map((item, inx1) =>
                            <li id={'ltgame_' + inx1} key={'ltgam_' + inx1} onClick={() => { item.game_type_id == 11 ? this.LoadPoker(item) : history.push("/" + item.game_url) }}>
                                <a> <img src={item.game_icon} /></a>
                            </li>
                        )}
                    </ul>
                </>}

                {/* Loading Separate Page In Search Option roluette , poker. */}
                {this.props.renderkey == 8 && this.state.casinogames && this.state.casinogames.length > 0 && <>
                    <ul>
                        {this.state.casinogames.filter(a => a.types == 4).filter(game =>
                            game.game_type_name?.toLowerCase().includes(this.props.slotnamefilter.toLowerCase())
                        ).map((item, inx1) =>
                            <li id={'ltgame_' + inx1} key={'ltgam_' + inx1} onClick={() => { item.game_type_id == 11 ? this.LoadPoker(item) : history.push("/" + item.game_url) }}>
                                <a> <img src={item.game_icon} /></a>
                            </li>
                        )}
                    </ul>
                </>}
                {/* {this.props.renderkey == 6 && <li><a onClick={() => { this.LoadPoker() }}>Poker</a></li>} */}
            </>

        )
    }

}


function mapStateToProps(state) {
    const { latestResult, casinogames } = state.gameReducer;
    const { user, appvariables } = state.loginReducer;
    return { user, latestResult, appvariables, casinogames };
}
const mapActionToProps = {
    alertError: alertActions.error,
    GetCasinoGames: gameActions.GetCasinoGames,
    loadingIframe: alertActions.loadingIframe,
    loadedIframe: alertActions.loadedIframe

}
export default connect(mapStateToProps, mapActionToProps)(withTranslation()(RenderCasino))

